import { EventEmitter, InjectionToken, Input, Output, Directive } from '@angular/core';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { BaseItemModelService } from '@fi-app/template/base-item.model';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';

@Directive()
export abstract class FiDocumentLayoutItem {
    constructor(private templateLayoutLanguageService: TemplateLayoutLanguageService) {}

    @Input() item: BaseItemModelService;
    @Input() disableEdit: boolean = false;
    @Input() compareWith;
    @Input() languageId: number;
    @Input() templateLayoutHelper: TemplateLayoutHelper;

    @Output() itemColumnClick = new EventEmitter<number>();
    @Output() contentChange = new EventEmitter();
    @Output() afterViewInit = new EventEmitter();

    existingMediaBankFileReferences: IMediaBankFileReference[] = [];

    ngOnInit() {
        // find all existing media bank files
        this.addExistingMediaBankFileReferences(this.templateLayoutHelper.getAllMediaReferences());
    }

    private addExistingMediaBankFileReferences(mediaBankFileReferences: IMediaBankFileReference[]) {
        if (!mediaBankFileReferences) return;
        const addedMediaBankFileIds = this.existingMediaBankFileReferences.map(
            (existingItem) => existingItem.MediaBankFileId,
        );
        const mediaBankFileReferencesToAdd = mediaBankFileReferences.filter(
            (item) => addedMediaBankFileIds.indexOf(item.MediaBankFileId) === -1,
        );
        this.existingMediaBankFileReferences.push(...mediaBankFileReferencesToAdd);
    }

    oneColumn() {
        return this.item.model.Settings.Columns === 1;
    }

    doubleColumn() {
        return this.item.model.Settings.Columns === 2;
    }

    IsLayoutLanguageSelected(languageId) {
        return this.languageId
            ? this.languageId == languageId
            : this.templateLayoutLanguageService.IsLayoutLanguageSelected(languageId);
    }

    columnClick(column: number) {
        this.itemColumnClick.emit(column);
    }

    protected _rendered() {
        this.afterViewInit.emit();
    }

    onColumnAfterRender(column: number) {
        if ((column === 1 && this.oneColumn()) || (column === 2 && this.doubleColumn())) this._rendered();
    }
}
